import { isNonEmptyString } from '@/utils/checks'
import {
  isLevelsOfCareFacetPageType,
  isLevelsOfCarePageType
} from '../pageTypeCheck'
import { PROVIDER_TYPES_TO_BOOST } from './constants'
import { Center } from '@/types/models'
import { getProviderType } from '@/domain/center'
import { PageType } from '@/types/models/PageType.model'

function isEligibleForProviderTypeBoost(
  searchTerm: string,
  center: Center,
  pageType?: PageType
): boolean {
  const providerType = getProviderType(center)
  return (
    isNonEmptyString(searchTerm) &&
    !center?.fromBrowseSearch &&
    isNonEmptyString(pageType) &&
    (isLevelsOfCarePageType(pageType) ||
      isLevelsOfCareFacetPageType(pageType)) &&
    isNonEmptyString(providerType) &&
    PROVIDER_TYPES_TO_BOOST.includes(providerType)
  )
}

export default isEligibleForProviderTypeBoost
